const redirectToClient = (redirect: string, token: string) => {
  window.location.href = `${redirect}?access_token=${token}`;
};

export default redirectToClient;
